import { JobIdResponse } from 'api/jobs/jobs.types';
import { AddOwnersFromFileResponse, AddOwnersWithPhotosResponse } from 'api/owners/owners.types';

/**
 * Type guards for PKD import responses
 * Used to distinguish between sync responses and async job responses
 */

/**
 * Checks if response is a JobIdResponse (async operation)
 */
export const isPkdImportJobResponse = (
  response: AddOwnersFromFileResponse | JobIdResponse,
): response is JobIdResponse => {
  return 'jobId' in response && typeof response.jobId === 'string';
};

/**
 * Checks if response is a sync AddOwnersFromFileResponse
 */
export const isPkdImportSyncResponse = (
  response: AddOwnersFromFileResponse | JobIdResponse,
): response is AddOwnersFromFileResponse => {
  return 'liczbaDodanych' in response || 'liczbaZmodyfikowanych' in response;
};

/**
 * Checks if response is a JobIdResponse for photo imports (async operation)
 */
export const isPkdPhotoImportJobResponse = (
  response: AddOwnersWithPhotosResponse | JobIdResponse,
): response is JobIdResponse => {
  return 'jobId' in response && typeof response.jobId === 'string';
};

/**
 * Checks if response is a sync AddOwnersWithPhotosResponse
 */
export const isPkdPhotoImportSyncResponse = (
  response: AddOwnersWithPhotosResponse | JobIdResponse,
): response is AddOwnersWithPhotosResponse => {
  return 'liczbaDodanych' in response || 'liczbaZmodyfikowanych' in response || 'filesNotMatch' in response;
};
